module.exports = ".blueFont,\n.lightBlueFont,\n.greenFont,\n.redFont {\n  font-size: 1.3rem;\n}\n\n.greyFont {\n  color: #688091;\n}\n\n.blueFont {\n  color: #57A3D9;\n}\n\n.lightBlueFont {\n  color: #57B9D9;\n}\n\n.greenFont {\n  color: #26BF99;\n}\n\n.redFont {\n  color: #D96C7E;\n}\n\n.row {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.emBtn {\n  background-color: #36B36A;\n  color: white;\n}\n\n.versorgungsBtn {\n  background-color: #5782D9;\n  color: white;\n}\n\n.diagramContainer {\n  margin-top: 100px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/auswertung/uebersicht/uebersicht.component.css
// module id = ./src/app/auswertung/uebersicht/uebersicht.component.css
// module chunks = main